export default function showFile(blob, name, type, ext, id) {
	var newBlob = new Blob([blob], { type: type });
	// IE doesn't allow using a blob object directly as link href
	// instead it is necessary to use msSaveOrOpenBlob
	if (window.navigator && window.navigator.msSaveOrOpenBlob) {
		window.navigator.msSaveOrOpenBlob(newBlob);
		return;
	}

	// For other browsers:
	// Create a link pointing to the ObjectURL containing the blob.
	const data = window.URL.createObjectURL(newBlob);
	var link = document.createElement("a");
	var br = document.createElement("br");
	link.href = data;
	if (!!ext) {
		link.download = name + "." + ext;
		link.innerHTML = name + "." + ext;
	} else {
		link.download = name;
		link.innerHTML = name;
	}

	if (!!id) {
		document.getElementById(id).append(link);
		document.getElementById(id).append(br);
	} else {
		link.click();
	}
}

export function showFileXLS(blob, name, type, ext, id) {
	function s2ab(s) {
		var buf = new ArrayBuffer(s.length);
		var view = new Uint8Array(buf);
		for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
		return buf;
	}

	var newBlob = new Blob([s2ab(atob(blob))], {
		type: type,
	});
	// var newBlob = new Blob([blob], { type: type })
	// IE doesn't allow using a blob object directly as link href
	// instead it is necessary to use msSaveOrOpenBlob
	if (window.navigator && window.navigator.msSaveOrOpenBlob) {
		window.navigator.msSaveOrOpenBlob(newBlob);
		return;
	}

	// For other browsers:
	// Create a link pointing to the ObjectURL containing the blob.
	const data = window.URL.createObjectURL(newBlob);
	var link = document.createElement("a");
	var br = document.createElement("br");
	link.href = data;
	link.download = name + "." + ext;
	link.innerHTML = name + "." + ext;

	if (!!id) {
		document.getElementById(id).append(link);
		document.getElementById(id).append(br);
	} else {
		link.click();
	}
}
